import { IGeocodeFeature, IMapboxSuggestion } from '@/services/types/mapbox/mapboxApi';

export const getMapboxFeatureId = (feature: IGeocodeFeature | IMapboxSuggestion | undefined) => {
  return feature && 'mapbox_id' in feature ? feature.mapbox_id : feature?.id;
};
